import { toast } from '@heidi/design-system/toast';
import { useMutateUpdateSessionSocketError as useMutateUpdateSessionSocketErrorCore } from '@heidi/session/data';

export function useMutateUpdateSessionSocketError() {
  return useMutateUpdateSessionSocketErrorCore({
    onUpdateSocketError: (error) =>
      toast({
        tone: 'destructive',
        title: 'There was an error updating the session. Please try again.',
        description: error.message,
      }),
  });
}
